var alignment_rtlignore_default = {
  "alignLeft": "qDAu-",
  "textWrapNowrap": "KZYng",
  "alignRight": "Ry-90",
  "alignCenter": "avtTW",
  "sizeFullWidth": "iECj3",
  "renderedInTable": "Drn-g",
  "sizeOriginal": "huVCt",
  "sizeContent": "XfjX5",
  "sizeSmall": "_9HuXU",
  "sizeSmallCenter": "HFyfM",
  "flex": "purgs",
  "LEFT": "xJPDa",
  "CENTER": "I4Wwn",
  "RIGHT": "nH9fe",
  "AUTO": "od2cv",
  "JUSTIFY": "Vd6JC"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
